<template>
  <span>
    <div
      class="di-flex justify-space-around p row-reversable"
      style="
        margin-top: 5px;
        margin-bottom: 5px;
        font-size: 11pt;
        font-weight: 600;
      "
    >
      <span>{{ $t("sign") }}</span>
      <span>{{ $t("cashire_sign") }}</span>
      <span>{{ $t("approved_by") }}</span>
      <!-- <span>{{ $t("compliance_sign") }}</span> -->
    </div>

    <v-divider style="margin-bottom: 5px; margin-top: 25px"></v-divider>
    <div
      class="di-flex justify-space-between align-center"
      style="font-size: 12px"
    >
      <div>
        <div class="font-weight-bold">
          <strong class="px-2">{{ $t("address") }} : </strong>
          <span>{{ userBranch.address }}</span>
        </div>
        <div class="font-weight-bold">
          <strong class="px-2">{{ $t("phones") }} : </strong>
          <span>{{ userBranch.pretty_phone }}</span>
        </div>
        <div class="font-weight-bold">
          <strong class="px-2">{{ $t("email") }} : </strong>
          <span>{{ userBranch.email }}</span>
        </div>
        <div class="font-weight-bold">
          <strong class="px-2">{{ $t("user") }} : </strong>
          <span>{{ user && user.name }} - {{ user && user.branch.code }}</span>
        </div>
      </div>
      <div class="di-flex font-weight-bold" style="justify-content: flex-end">
        <img :src="qrcode" alt="SO" style="width: 20mm; height: 20mm" />
      </div>
    </div>
  </span>
</template>
<script>
export default {
  props: {
    userProp: {
      default: () => {
        branch: {
        }
      },
    },
  },
};
</script>
